import React from 'react'
import styled from 'styled-components/macro'
import { MEDIA, COLORS } from '../../utils/styles'
import Link from 'wsc/components/Link'
import has from 'lodash/has'

const ScContactDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  order: 1;
  justify-content: center;
  margin-bottom: 30px;
  
  ${MEDIA.MOBILE`
    width: 81%; // fixed width for display 3 links on first line
  `}

  ${MEDIA.TABLET`
    width: 100%;
  `}

  ${MEDIA.DESKTOP`
    justify-content: left;
    margin-bottom: 12px;
  `}
`
const ScLink = styled(Link)`
  font-weight: 600;
  margin: 0 11.5px;
  border: none;
  color: ${COLORS.WHITE};

  &:active {
    color: ${COLORS.DARK_YELLOW};
  }

  ${MEDIA.DESKTOP` 
    text-align: left; 
    margin-left: 0;
    margin-right: 23px;

    &:hover {
      color: ${COLORS.YELLOW};
    }
  `}
`

/*----------------------------------------------------------------------------------
 *  RENDER PHASE
 *---------------------------------------------------------------------------------*/

const CONTACT_LIST = [
  {
    label: 'ABOUT',
    url: 'https://mom.com/about',
  },
  {
    label: 'TERMS',
    url: 'https://www.wildskymedia.com/terms-of-service/',
  },
  {
    label: 'PRIVACY',
    url: 'https://www.wildskymedia.com/privacy-policy/',
  },
  {
    label: 'CONTACT',
    url: 'https://mom.com/contact',
  },
  {
    label: 'ADVERTISING',
    url: 'mailto:sales@wildskymedia.com',
  },
  {
    label: 'PRIVACY SETTINGS',
    url: '/#',
    onClick: () => {
      window.Optanon.ToggleInfoDisplay()
    },
  },
  {
    label: 'SUBMIT A STORY IDEA',
    url: 'https://mom.com/submissions',
  },
]

const FooterContact = () => {
  const contactLink = CONTACT_LIST.reduce((result, contact) => {
    const linkParams = { to: contact.url, key: contact.label }
    if (has(contact, 'onClick')) {
      linkParams['onClick'] = contact.onClick
    }
    result.push(<ScLink {...linkParams}>{contact.label}</ScLink>)
    return result
  }, [])

  return <ScContactDiv>{contactLink}</ScContactDiv>
}

FooterContact.propTypes = {}

FooterContact.defaultProps = {}

export default FooterContact
